<template>
	<div class="p-0 h-100 widget-local-monitor">
		<div class="local-monitor___table"><sf-data-table :columns="columns" :rows="rows" /></div>
		<div class="sf-widget-footer">
			<div class="d-flex align-items-center h-100">
				<span class="flex-grow-1">
					<sf-tag color="green">Running</sf-tag>
				</span>
				<span class="text-red flex-grow-1">Total:22</span>
				<span class="text-green flex-grow-1">Current:19</span>
				<span class="text-blue flex-grow-1">Remain:4</span>
				<span class="flex-grow-1">2021-06-08 12:23:45</span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	methods: {
		refresh() {
			return [];
		}
	},
	data() {
		return {
			columns: [
				{ label: 'SEQ', prop: 'seq' },
				{ label: 'Type', prop: 'type' },
				{ label: 'B/NO', prop: 'bno' },
				{ label: 'Model', prop: 'model' },
				{ label: 'Front Glass', prop: 'fontGlass' }
			],
			rows: [
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' },
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' },
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' },
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' },
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' },
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' },
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' },
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' },
				{ seq: '0003', type: 'F9F', bno: '000510', model: 'Model Name', fontGlass: 'Y3' }
			]
		};
	}
};
</script>
